import dataSourceHelper from '../../../../infrastructure/helpers/functions/common/dataSourceHelper';
import pseudocodeHelper from '../../../../infrastructure/helpers/functions/common/pseudocodeHelper';
import dictionaryHelper from '../../../../infrastructure/helpers/functions/dictionaries/dictionaryHelper';
import SelectOption from '../../../../infrastructure/types/SelectOption';
import IngestionConfig from '../../../../types/ingestion/IngestionConfig';
import Dictionary from '../../../../types/report/Dictionary';

const createOption = (dict: Dictionary, dataSources: IngestionConfig[]): SelectOption => {

    let dataSource = dataSourceHelper.getById(dataSources, dict.dataSourceId as number);

    return {
        value: dict.number.toString(),
        text: pseudocodeHelper.wrapInBrackets(dictionaryHelper.getName(dict, dataSource.name))
    };
};

export { createOption };
